<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="12"> Formas de pagamento</v-col>
        <v-col cols="12">
          <v-text-field v-model="searchFilter" append-inner-icon="mdi-magnify" label="Filtrar resultados" clearable
            single-line hide-details>
            <template v-slot:append>
              <DialogCreateUpdatePaymentMethod :cashierID="cashierID" :floatRight="true" v-model="editModel"
                @created="createdObject" @updated="updatedObject" />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="lstObjects"
      :search="searchFilter"
      return-object
      class="elevation-1"
      hide-default-footer
    >
      <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination :disabled="requestingApi" v-model="page" :length="maxPage"></v-pagination>
        </div>
      </template>
      <template v-slot:item.id="{ item }">
        <span :class="{ 'text-green': item.enabled, 'text-red': !item.enabled }">{{
          item.id
        }}</span>
      </template>
      <template v-slot:item.name="{ item }">
        <span :class="{ 'text-green': item.enabled, 'text-red': !item.enabled }">{{
          item.name
        }}</span>
      </template>
      <template v-slot:item.description="{ item }">
        <span :class="{ 'text-green': item.enabled, 'text-red': !item.enabled }">{{
          item.description
        }}</span>
      </template>
      <template v-slot:item.type="{ item }">
        <span :class="{ 'text-green': item.enabled, 'text-red': !item.enabled }">{{
          $PAYMENT_METHOD_TYPES_DIC[item.type]
          ? $PAYMENT_METHOD_TYPES_DIC[item.type].label
          : item.type
        }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list>
            <v-list-item @click="editModel = item">
              <v-list-item-title><v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                Editar</v-list-item-title>
            </v-list-item>
            <v-list-item @click="deletePaymentMethod(item)">
              <v-list-item-title><v-icon color="red" class="mr-2">mdi-delete</v-icon>
                Remover</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import DialogCreateUpdatePaymentMethod from "./DialogCreateUpdatePaymentMethod.vue";
import api from '@/services'

export default {
  components: { DialogCreateUpdatePaymentMethod },
  props: {
    user: Object,
    cashierID: Number,
  },
  data() {
    return {
      requestingApi: false,
      lstObjects: [],
      headers: [
        { title: "ID", align: "start", key: "id", sortable: true },
        { title: "Nome", align: "start", key: "name", sortable: true },
        {
          title: "Descrição",
          align: "start",
          key: "description",
          sortable: true,
        },
        { title: "Tipo", align: "start", key: "type", sortable: true },
        // { title: "Taxas 1", align: "end", key: "tax_1", sortable: true },
        // { title: "Taxas 2", align: "end", key: "tax_2", sortable: true },
        // { title: "Taxas 3", align: "end", key: "tax_3", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      editModel: {},
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.submitSearch();
  },
  mounted() { },
  activated() { },
  methods: {
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.paymentMethod
            .list({ cashier_id: vm.cashierID }, page || 1)
            .then((result) => {
              vm.lstObjects = result?.data;
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    deletePaymentMethod(paymentMethod) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.paymentMethod
            .delete(paymentMethod)
            .then((result) => {
              vm.$notify({
                type: "success",
                text: "Forma de pagamento removida",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.submitSearch();
            });
        });
      }
    },
    createdObject(val) {
      var vm = this;
      vm.lstObjects.unshift(val);
      vm.editModel = {}
    },
    updatedObject(val) {
      var vm = this;
      let _ixEdited = vm.lstObjects.findIndex((x) => x.id === val.id);
      vm.lstObjects[_ixEdited] = val;
      vm.editModel = {}
    },
  },
  computed: {},
  watch: {
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>